import type { Game } from '../types';

/**
 * Get the spread display string showing the favored team and spread value
 * @param game - The game object containing spread information
 * @returns Formatted spread string like "Alabama -7" or empty string if no spread
 */
export const getSpreadDisplay = (game: Game | { spread?: number; home_team: string; away_team: string }): string => {
  if (!game.spread) return '';
  
  // Normalized spread format: negative = home team favored, positive = away team favored
  const favoredTeam = game.spread < 0 ? game.home_team : game.away_team;
  const spreadValue = Math.abs(game.spread);
  
  return `${favoredTeam} -${spreadValue}`;
};

/**
 * Get the favored team from the spread
 * @param game - The game object containing spread information
 * @returns The name of the favored team or null if no spread
 */
export const getFavoredTeam = (game: Game | { spread?: number; home_team: string; away_team: string }): string | null => {
  if (!game.spread) return null;
  
  // Normalized spread format: negative = home team favored, positive = away team favored
  return game.spread < 0 ? game.home_team : game.away_team;
};

/**
 * Check if a team is favored in the spread
 * @param game - The game object containing spread information
 * @param teamName - The team name to check
 * @returns True if the team is favored, false otherwise
 */
export const isTeamFavored = (game: Game | { spread?: number; home_team: string; away_team: string }, teamName: string): boolean => {
  const favoredTeam = getFavoredTeam(game);
  return favoredTeam === teamName;
};
